import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import YuqueFilledSvg from "@ant-design/icons-svg/es/asn/YuqueFilled";
import AntdIcon from "../components/AntdIcon";
var YuqueFilled = function YuqueFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: YuqueFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  YuqueFilled.displayName = 'YuqueFilled';
}
export default /*#__PURE__*/React.forwardRef(YuqueFilled);